export default __webpack_public_path__ + "static/hugeSuccess-475fa1b26a800a392422216eaf939425.webp";